import { Directive, Injectable, Input } from '@angular/core';

@Injectable()
@Directive()
export abstract class BaseViewerComponent {
    @Input() blobUrl!: string;
    @Input() originalSourceUrl!: string;
    @Input() extension!: string;
}
